<template>
  <div class="root">
    <div class="public-notice">
      <el-carousel
        direction="vertical"
        :autoplay="true"
        indicator-position="none"
      >
        <el-carousel-item v-for="item in noticesList" :key="item.noticeId">
          <div class="medium" @click="jumpNoticeDetail(item)">
            公告：{{ item.noticeTitle }}
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="cate-content">
        <div :class="categoryIndex > 0 ? 'left show-category-view':'left ' " style="flex:1.2;">
        <div :class="categoryIndex == index ? 'left-category left-category-a' : 'left-category' "
            v-for="(item, index) in category"
            @mouseover="categoryMouseOver(item,index)"
            :key="index">
            <div class="category-name" >
                <img class="category-icon" :src="item.icon"/>
                <div class="name" @click="categoryItemClick(item.categoryName)">{{item.categoryName}}</div>
                <!-- <div class="name" @click="searchByCate(index,item,item.categoryName)">{{item.categoryName}}</div> -->
            </div>
            <ul class="category-row" >
                <li v-for="(categoryItem, categoryIndex) in item.categoryItemList.slice(0,4)" :key="categoryIndex">
                    <!-- <a  @click="searchByCate(index,categoryItem,categoryItem.name)"> -->
                    <a  @click="categoryItemClick(categoryItem.name)">
                        <h4 class="h4">{{categoryItem.name}}</h4>
                    </a>
                </li>
            </ul>
        </div>
        <div class="test-view">
            <div class="cate-ctn" v-for="(cateItem, cateIndex) in categoryItemList" :key="cateIndex">
                <a href="#" class="c-n">{{cateItem.name}}</a>
                <div class="c-list">
                    <a class="c-l-items" v-for="(listItem, listIndex) in cateItem.list" :key="listIndex" @click="categoryItemClick(listItem)">{{listItem}}</a>
                </div>
            </div>
        </div>
    </div>
    <div class="mid" style="flex:3">
        <el-carousel indicator-position="none" style="height:430px">
            <el-carousel-item
                v-for="(item,index) in bannerList"
                class="banner-item"
                :key="index"
                :style="{
                backgroundImage: 'url('+ item +')',
                'height': '430px'
                }">
            </el-carousel-item>
        </el-carousel>
    </div>
    <div class="right" style="flex:1.2;">
        <div class="right-top">
            <div class="right-top-title">欢迎来到江城百臻</div>
            <div class="right-top-auth" v-if="!isLogin" >
                <div class="auth-login"  @click="loginOption">登录</div>
                <div class="auth-registe" @click="registeOption">免费注册</div>
            </div>
            <div class="right-top-logined" v-if="isLogin">
                <div class="image">
                    <el-avatar :size="50" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                </div>
                <div class="content">
                    <div>Hi,{{ $store.state.userInfo.phone }}</div>
                    <div class="content1">尽享专属服务</div>
                </div>
            </div>
        </div>
         <div class="right-bottom">
            <div class="right-bottom-title">买家服务</div>
            <div class="right-bottom-service">
                  <div class="service-item" @click="serviceBuy()">
                    <i class="el-icon-shopping-cart-full el-icon-s-self" />
                    <div class="item-title">采购管理</div>
                  </div>
                  <div class="service-item" @click="serviceOrder()">
                    <i class="el-icon-s-order el-icon-s-self" />
                    <div class="item-title">订单管理</div>
                  </div>
                  <div class="service-item" @click="serviceCoupon()">
                    <i class="el-icon-money el-icon-s-self" />
                    <div class="item-title">优惠券</div>
                  </div>
            </div>
            <div class="right-bottom-user" @click="userCenterOption">
                进入买家中心<i class="el-icon-arrow-right"/>
            </div>
         </div>
        </div>
    </div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%">
        <span>{{dialogTitle}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import Cookie from 'js-cookie'
import { getUserInfo } from '@/api/user/user.js'
import { getGongGaoAll } from '@/api/user/notice.js'
import {mapMutations, mapGetters} from 'vuex'
import {
    getTypeList
} from '@/api/home/supply.js'
export default {
  props: ['afterSaleList', 'page', 'total'],
  data () {
    return {
      noticesList: [],
      userInfoData: '',
      isLogin: false,
      dialogVisible: false,
      dialogTitle: '',
      bannerList: [
        '../../../static/image/index/03-01.jpg',
        '../../../static/image/index/03-02.jpg',
        '../../../static/image/index/03-03.jpg',
      ],
      category: [
        {
            categoryName: '水果',
            icon: 'https://files.cnhnb.com/pc/home/cate-sgzw.png',
            categoryItemList: [
                {
                    name: '热带水果',
                    // list: ['芒果', '荔枝', '龙眼', '菠萝', '火龙果', '香蕉', '榴莲', '木瓜', '莲雾', '山竹', '椰子', '甘蔗', '菠萝蜜', '牛油果', '橄榄', '杨桃', '蛋黄果', '黄晶果', '余甘果', '人心果', '诺丽果', '榴莲蜜', '番石榴', '木鳖果', '龙功果']
                },
                {
                    name: '柑橘类',
                    // list: ['柠檬', '柑桔', '金桔橙子', '柚子']
                },
                {
                    name: '浆果类',
                    // list: ['葡萄', '草莓', '树莓', '圣女果', '桑甚', '蓝莓', '黑果花楸果', '猕猴桃', '柿子', '百香果', '黑莓', '树葡萄', '蓝靛果', '沙棘果', '马蹄', '姑娘果', '权杷果', '无花果', '牛奶果', '桃金娘', '白刺果', '野地瓜', '羊奶果', '仙人掌果', '神秘果']
                },
                {
                    name: '瓜果类',
                    // list: ['西瓜', '甜瓜', '哈密瓜', '八月瓜', '火参果', '九月瓜', '地稍瓜', '泡泡果']
                },
            ],
        },
        {
            categoryName: '蔬菜',
            icon: 'https://files.cnhnb.com/pc/home/cate-sczw.png',
            categoryItemList: [
                {
                    name: '葱姜蒜类',
                    // list: ['芒果', '荔枝', '龙眼', '菠萝', '火龙果', '香蕉', '榴莲', '木瓜', '莲雾', '山竹', '椰子', '甘蔗', '菠萝蜜', '牛油果', '橄榄', '杨桃', '蛋黄果', '黄晶果', '余甘果', '人心果', '诺丽果', '榴莲蜜', '番石榴', '木鳖果', '龙功果']
                },
                {
                    name: '根茎菜类',
                    // list: ['柠檬', '柑桔', '金桔橙子', '柚子']
                },
                {
                    name: '叶菜类',
                    // list: ['葡萄', '草莓', '树莓', '圣女果', '桑甚', '蓝莓', '黑果花楸果', '猕猴桃', '柿子', '百香果', '黑莓', '树葡萄', '蓝靛果', '沙棘果', '马蹄', '姑娘果', '权杷果', '无花果', '牛奶果', '桃金娘', '白刺果', '野地瓜', '羊奶果', '仙人掌果', '神秘果']
                },
                {
                    name: '菌',
                    // list: ['西瓜', '甜瓜', '哈密瓜', '八月瓜', '火参果', '九月瓜', '地稍瓜', '泡泡果']
                },
            ],
        },
        {
            categoryName: '禽畜肉蛋',
            icon: 'https://files.cnhnb.com/pc/home/cate-qcrd.png',
            categoryItemList: [
                {
                    name: '禽畜苗',
                    // list: ['鸡苗', '鸭苗', '鹅苗', '猪苗', '鹌鹑苗']
                },
                {
                    name: '蛋类',
                    // list: ['鸡蛋', '鸭蛋', '鹌鹑蛋', '鹅蛋', '鸽子蛋', '皮蛋', '咸蛋', '毛蛋', '种蛋']
                },
                {
                    name: '活畜',
                    // list: ['牛', '羊', '生', '猪', '驴', '兔子']
                },
                {
                    name: '活禽',
                    // list: ['鸡', '鸭', '鹅', '鹌鹑']
                }
            ],
        },
        {
            categoryName: '水产',
            icon: 'https://files.cnhnb.com/pc/home/cate-shuic.png',
            categoryItemList: [
                {
                    name: '水产种苗',
                    // list: ['芒果', '荔枝', '龙眼', '菠萝', '火龙果', '香蕉', '榴莲', '木瓜', '莲雾', '山竹', '椰子', '甘蔗', '菠萝蜜', '牛油果', '橄榄', '杨桃', '蛋黄果', '黄晶果', '余甘果', '人心果', '诺丽果', '榴莲蜜', '番石榴', '木鳖果', '龙功果']
                },
                {
                    name: '虾类',
                    // list: ['柠檬', '柑桔', '金桔橙子', '柚子']
                },
                {
                    name: '贝类',
                    // list: ['葡萄', '草莓', '树莓', '圣女果', '桑甚', '蓝莓', '黑果花楸果', '猕猴桃', '柿子', '百香果', '黑莓', '树葡萄', '蓝靛果', '沙棘果', '马蹄', '姑娘果', '权杷果', '无花果', '牛奶果', '桃金娘', '白刺果', '野地瓜', '羊奶果', '仙人掌果', '神秘果']
                },
                {
                    name: '食用鱼类',
                    // list: ['西瓜', '甜瓜', '哈密瓜', '八月瓜', '火参果', '九月瓜', '地稍瓜', '泡泡果']
                },
            ],
        },
        {
            categoryName: '农副加工',
            icon: 'https://files.cnhnb.com/pc/home/cate-nfjg.png',
            categoryItemList: [
                {
                    name: '加工产品',
                    list: ['糖', '汤', '菌', '休闲食品', '蜜', '其他']
                },
                // {
                //     name: '干果坚果',
                //     list: ['柿饼', '红枣', '枸杞', '核桃', '瓜子', '板粟', '葡萄干', '桂圆干', '山楂干', '白果', '芡实', '榛子', '巴旦木', '杏仁', '沙漠果', '香榧', '开心果', '夏威夷果', '碧根果', '腰果', '莲子', '风流果', '棯子干', '松子', '椰枣']
                // },
                // {
                //     name: '茶叶',
                //     list: ['黑茶', '普洱', '乌龙茶', '绿茶', '红茶', '花草茶', '黄茶', '白茶', '茶粉']
                // },
                // {
                //     name: '肉制品加工',
                //     list: ['熟羊肉', '火腿', '腊肉', '板鸭', '肉卷', '腌/咸鸭', '腌/咸肉', '腌/咸鹅', '腌/咸鸡', '烧鸡', '卤鸭', '熟牛肉', '熟鸡肉', '熟鸽肉', '熟鹅肉', '腊羊肉', '腊鸭', '腊味组合', '腊牛肉', '腊鸡', '腊鹅', '腊鹌鹑', '烤鸭', '香肠/腊肠', '熟猪肉']
                // },
                // {
                //     name: '水产加工',
                //     list: ['籽乌干', '章鱼干', '鱼鳞干', '鱿鱼干', '腌/咸螺', '蚬子干', '腌/咸鱼', '虾仁', '虾皮', '虾干', '沙虫干', '墨鱼干', '卤甲鱼', '龙须菜干', '腊鱼', '酱板鱼', '海蜇干', '海茸干', '海米', '海虹干', '干裙带菜', '干贝', '蛏干', '鲍鱼干', '鱼籽鱼泡']
                // },
                // {
                //     name: '营养滋补',
                //     list: ['蜂蜜', '花粉', '桃胶', '雪燕', '皂角米', '鱼鳔', '蜂王浆']
                // },
                // {
                //     name: '速食品',
                //     list: ['速冻蔬果', '饼干糕点', '蜜饯果脯', '休闲零食', '罐头', '方便食品', '糖果', '丸滑类', '冲饮']
                // },
            ],
        },
        {
            categoryName: '粮油米面',
            icon: 'https://files.cnhnb.com/pc/home/cate-lymm.png',
            categoryItemList: [
                {
                    name: '加工产品',
                    list: ['面', '米', '油']
                },
                // {
                //     name: '食用油',
                //     //, '石榴籽油', '文冠果油', '山桐子油', '棉籽油', '马泡油'
                //     list: ['牛油果油', '山茶油', '花生油', '橄榄油', '玉米油', '菜籽油', '葵花籽油', '色拉油', '火麻油', '亚麻籽油', '红花籽油', '核桃油', '秋葵油', '黄芥油', '杏仁油', '苏籽油', '花椒油', '牡丹籽油', '芝麻油', '椰子油']
                // },
                // {
                //     name: '调味品',
                //     list: ['菌油', '味精', '鸡精', '糖', '醋', '酱油', '蚝油', '调味酱', '剁椒', '调味油', '料酒', '火锅底料', '调味料', '香茅', '汤料', '泡椒', '卤料', '花生碎', '调味粉', '盐']
                // },
                // {
                //     name: '香辛料',
                //     //, '八角', '姜粉', '香砂仁', '香草', '干丁香', '姜黄', '肉桂', '豆蔻', '草果', '芥菜籽', '花椒枝', '洋葱粉'
                //     list: ['桂子', '千里香', '莳萝子', '胡椒粉', '杜松子', '百里香', '干辣椒', '辣椒粉', '胡椒', '孜然', '花椒', '桂皮', '陈皮']
                // },
                // {
                //     name: '谷物粉淀粉',
                //     list: ['淀粉', '面粉', '粘米粉', '黄豆面', '燕麦粉', '马蹄粉', '高粱面粉', '玉米面', '豆面', '红豆粉', '糯米粉', '木薯粉', '红薯干粉', '绿豆粉', '黍米粉', '大豆粉', '豌豆面', '山芋粉', '全粉', '蔬菜粉', '黑米面', '菠菜粉', '莜麦粉', '青稞粉', '荞麦粉']
                // },
                // {
                //     name: '豆制品',
                //     //, '腊八豆', '豆笋', '豆钱子', '豆卷', '纳豆', '素火腿', '醋泡黑豆', '腐皮卷', '豆结', '豆参'
                //     list: ['霉豆渣', '豆豉', '豆腐', '香干', '腐乳', '千张', '兰花干', '素鸡', '腐竹', '豆腐皮', '蛋白肉', '食用豆饼']
                // },
                // {
                //     name: '面食米食',
                //     //, '面筋', '馄饨', '面花', '凉皮', '凉粉', '饺子皮', '馄饨皮', '粉皮', '粉丝粉条', '糯米鸡'
                //     list: ['饽饽', '凉糕', '肠粉', '锅贴', '西米', '馒头', '焖子', '面条', '饺子', '汤圆', '包子', '烧麦']
                // },
            ],
        },
        {
            categoryName: '种子种苗',
            icon: 'https://files.cnhnb.com/pc/home/cate-zzzm.png',
            categoryItemList: [
                {
                    name: '乔木',
                    // list: ['芒果', '荔枝', '龙眼', '菠萝', '火龙果', '香蕉', '榴莲', '木瓜', '莲雾', '山竹', '椰子', '甘蔗', '菠萝蜜', '牛油果', '橄榄', '杨桃', '蛋黄果', '黄晶果', '余甘果', '人心果', '诺丽果', '榴莲蜜', '番石榴', '木鳖果', '龙功果']
                },
                {
                    name: '灌木',
                    // list: ['柠檬', '柑桔', '金桔橙子', '柚子']
                },
                {
                    name: '竹类植物',
                    // list: ['葡萄', '草莓', '树莓', '圣女果', '桑甚', '蓝莓', '黑果花楸果', '猕猴桃', '柿子', '百香果', '黑莓', '树葡萄', '蓝靛果', '沙棘果', '马蹄', '姑娘果', '权杷果', '无花果', '牛奶果', '桃金娘', '白刺果', '野地瓜', '羊奶果', '仙人掌果', '神秘果']
                },
                {
                    name: '棕榈类植物',
                    // list: ['西瓜', '甜瓜', '哈密瓜', '八月瓜', '火参果', '九月瓜', '地稍瓜', '泡泡果']
                },
            ],
        },
        {
            categoryName: '苗木花草',
            icon: 'https://files.cnhnb.com/pc/home/cate-mmhc.png',
            categoryItemList: [
                {
                    name: '热带水果',
                    // list: ['芒果', '荔枝', '龙眼', '菠萝', '火龙果', '香蕉', '榴莲', '木瓜', '莲雾', '山竹', '椰子', '甘蔗', '菠萝蜜', '牛油果', '橄榄', '杨桃', '蛋黄果', '黄晶果', '余甘果', '人心果', '诺丽果', '榴莲蜜', '番石榴', '木鳖果', '龙功果']
                },
                {
                    name: '柑橘类',
                    // list: ['柠檬', '柑桔', '金桔橙子', '柚子']
                },
                {
                    name: '浆果类',
                    // list: ['葡萄', '草莓', '树莓', '圣女果', '桑甚', '蓝莓', '黑果花楸果', '猕猴桃', '柿子', '百香果', '黑莓', '树葡萄', '蓝靛果', '沙棘果', '马蹄', '姑娘果', '权杷果', '无花果', '牛奶果', '桃金娘', '白刺果', '野地瓜', '羊奶果', '仙人掌果', '神秘果']
                },
                {
                    name: '瓜果类',
                    // list: ['西瓜', '甜瓜', '哈密瓜', '八月瓜', '火参果', '九月瓜', '地稍瓜', '泡泡果']
                },
            ],
        }
      ],
      serviceList: ['采购管理', '订单管理', '优惠券'],

      categoryItemList: [],
      categoryIndex: -1,
      }
  },
  watch: {
    '$store.state.isLogin': {
      handler (nVal, oVal) {
        this.isLogin = nVal
      }
    }
  },
  computed: {
    ...mapGetters([
        'searchObj',
        'homeSelectIndex'
    ])
  },
  created () {
    if (Cookie.get('token')) {
      this.isLogin = true
    }
    this.getNoticesData()
  },
  mounted () {
    this.getTypeList()
  },
  methods: {
    ...mapMutations({
        setSearchObj: 'SET_SEARCHOBJ',
        setHomeSelectIndex: 'SET_HOMESELECTINDEX'
    }),
    async getNoticesData () {
      const response = await getGongGaoAll()
      const res = response.data
      this.noticesList = res.data
    },
    jumpNoticeDetail (item) {
      this.$router.push({
        path: '/activity/notificationDetails',
        query: {
          id: item.noticeId
        }
      })
    },
    async getTypeList () {
        const response = await getTypeList()
        const res = response.data
      if (res.code === '200') {
        res.data.forEach(item => {
            const id = item.id
            if (id === 1) { // 农副加工
                this.category[4].categoryName = item.primaryName
                this.category[4].categoryItemList = []
                const childrenTypes = item.childrenType

                childrenTypes.forEach(ct => {
                    let categoryData = {}
                    categoryData = {'name': ct.bigName, 'list': ct.smallNames}
                    this.category[4].categoryItemList.push(categoryData)
                })
            } else if (id === 2) { // 粮油米面
                this.category[5].categoryName = item.primaryName
                this.category[5].categoryItemList = []
                const childrenTypes = item.childrenType

                childrenTypes.forEach(ct => {
                    let categoryData = {}
                    categoryData = {'name': ct.bigName, 'list': ct.smallNames}
                    this.category[5].categoryItemList.push(categoryData)
                })
            }
        })
      }
    },
    // 拓展分类点击
    categoryItemClick (item) {
      this.setSearchObj({
        keyword: item,
        searchVal: '商品'
      })
      this.setHomeSelectIndex(3)
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    // 个人信息
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        this.userInfoData = res.data
      } else {
        // this.$message.error('获取个人信息失败！')
      }
    },
    // 根据一级分类搜索
    searchByCate (index, item, name) {
        if (index === 4 || index === 5) {
            this.dialogTitle = '点击了--' + item + '--类目中的--' + name
            this.dialogVisible = true
        }
    },

    // 登录操作
    loginOption () {
      this.$store.commit('SHOW_LOGIN')
    },

    // 注册操作
    registeOption () {
      this.$store.commit('SHOW_LOGIN', '1')
    },

    // 服务点击操作
    serviceBuy () {
      if (Cookie.get('token')) {
        let item = {
            classifyName: '采购大厅',
            classifyImage: ''
        }
        this.$router.push({
            name: 'category',
            query: {
                tabIndex: 2,
                classifyData: JSON.stringify(item)
            }
        })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    serviceOrder () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/myOrder'})
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    serviceCoupon () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/couponPackage'})
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },

    // 进入买家中心
    userCenterOption () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/userInfo'})
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    categoryMouseOver (item, index) {
        this.categoryItemList = []
        this.categoryIndex = -1
        if (index === 4 || index === 5) {
            this.categoryItemList = item.categoryItemList
            this.categoryIndex = index
        }
    },
    categoryMouseOut () {
        this.categoryItemList = []
        this.categoryIndex = -1
    }
  }
}
</script>
<style lang="scss" scoped>
// .el-carousel__container {
//     height: 430px !important;
// }
.root{
  width: 100%;
  height: 460px;
  padding: 15px 8vw;
  box-sizing: border-box;
//   display: flex;
//   margin-top: 10px;
 .public-notice{
    width: 100%;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    // background-color: #666666;
    background-color:   #AAAAAA;

    .el-carousel{
        max-width: 1250px;
        height: 100%;
        margin: auto;
        color: #FFF;
        font-size: 12px;
        cursor: pointer;
    }
  }
  .cate-content{
    width: 100%;
    display: flex;
  .left{
    background: #fff;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-right: 10px;
    .left-category {
        // background-color: #e260bd;
        display: flex;
        flex-direction: column;
        padding: 6px 0px;
        margin-bottom: 4px;
        .category-name {
            display: flex;
            flex-direction: row;
            .category-icon {
                width:16px;
                height: 16px;
                margin-right: 10px;
                margin-left: 10px;
            }
            .name {
                height: 100%;
                font-size: 15px;
                color: #333333;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .name:hover {
                color: #4dc832;
                cursor: pointer;
            }
        }
        .category-row {
            display: flex;
            flex-direction: row;
            padding-left: 26px;
            margin-top: 5px;
            li {
                // background-color: #fff;
                margin-right: 10px;
                a{
                    display: flex;
                    h4{
                        font-size: 12px;
                        color: #666666;
                    }
                    .h4:hover {
                        color: #4dc832;
                    }
                }
            }
        }
    }
  }
  .test-view {
        position: absolute;
        top: 0;
        left: 100%;
        width: calc(250% + 20px);
        height: 100%;
        z-index: 99;
        display: none;

        background-color: #fff;
        box-shadow: 0 0 12px 0 rgba(0,0,0,.1);
        z-index: 99!important;

        .cate-ctn {
            box-sizing: border-box;
            border: none;
            margin-left: 24px;
            margin-right: 24px;
            width: calc(100% - 48px);

            .c-n {
                display: block;
                margin-top: 24px;
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #444;
                letter-spacing: 0;
                font-weight: 600;
            }
            .c-n:hover {
                color: #4dc832;
            }

            .c-list {
                    display: flex;
                    flex-wrap: wrap;

                    .c-l-items {
                        margin-top: 6px;
                        margin-right: 10px;
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #646464;
                        letter-spacing: 0;
                    }
                    .c-l-items:hover {
                        color: #4dc832;
                    }
            }
        }
    }
   .show-category-view:hover .test-view{
        display: block;
   }
   .left:hover .left-category-a{
        background: #fff;
        box-shadow: -11px 0 15px -4px rgba(0,0,0,.1);
        border-right: none;
   }
  .mid{
    width: 100%;
    height: 100%;
        .banner-item{
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            img{
                display: none;
            }
        }
        ::v-deep .el-carousel{
            height: 430px;
            .el-carousel__container{
                height: 100%;
            }
        }
    }
  .right{
    background: #fff;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    height: 100%;

    .right-top {
        display: flex;
        flex-direction: column;
        padding: 24px 16px;
        box-sizing: border-box;
        border: 1px solid #E5E5E5;

        .right-top-title {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333333;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 24px;
        }
        .right-top-auth {
            display: flex;
            flex-direction: row;
            justify-content: center;

            .auth-login {
                background: #4dc832;
                padding: 8px 10px;
                border-radius: 4;
                border: 1px solid #E5E5E5;
                font-size: 14px;
                color: #fff;
                font-weight: 500;
                width:90px;
                height: 35px;
                text-align: center;
                cursor: pointer;
            }
            .auth-registe {
                margin-left: 10px;
                background: #fff;
                padding: 8px 10px;
                border-radius: 4;
                border: 1px solid #E5E5E5;
                font-size: 14px;
                color: #4dc832;
                font-weight: 500;
                border-color: #4dc832;
                width:90px;
                text-align: center;
                cursor: pointer;
            }
        }
        .right-top-logined {
            display: flex;
            margin-left: 20px;
            .image{
                margin-right: 15px;
            }
            .content{
                margin-top: 4px;
                font-family: Helvetica;
                font-size: 18px;
                .content1 {
                    margin-top: 10px;
                    color: #909090;
                    letter-spacing: 0;
                    font-size: 14px;
                }
            }
        }
    }
    .right-bottom {
        display: flex;
        flex-direction: column;
        padding: 24px 16px;
        box-sizing: border-box;
        border: 1px solid #E5E5E5;
        background-color: #FFF;
        height: 285px;

        .right-bottom-title {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333333;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 16px;
        }
        .right-bottom-service {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-left: 10%;
            margin-right: 10%;

            .service-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;

                .el-icon-s-self {
                    width: 45px;
                    height: 45px;
                    font-size: 25px;
                    margin-bottom: 8px;
                    // background-color: #faa4a4;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #E5E5E5;
                }
                .item-title {
                    color: #333333;
                    font-size: 13px;
                    font-weight: 500;
                }

            }
            .service-item:hover{
                .el-icon-s-self {
                    color: #4dc832;
                    border-color: #4dc832;
                }
                .item-title {
                    color: #4dc832;
                }
            }

        }
        .right-bottom-user {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            width: 100%;
            align-items: center;
            justify-content: center;

            color: #4dc832;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            .el-icon-arrow-right {
                margin-top: 2px;
            }
        }
    }
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/category.vue